var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoTagRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0H12.6706C13.0002 0 13.3086 0.162442 13.4951 0.434246L17.6118 6.43425C17.8457 6.77515 17.8457 7.22485 17.6118 7.56575L13.4951 13.5658C13.3086 13.8376 13.0002 14 12.6706 14H1C0.447716 14 0 13.5523 0 13V1Z",
    fill: "url(#paint0_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145819,
    stopColor: "#49C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17707,
    stopColor: "#22CCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317701,
    stopColor: "#26ACE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348952,
    stopColor: "#304FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#5C51F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515626,
    stopColor: "#B656EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666673,
    stopColor: "#CB5EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687508,
    stopColor: "#FD72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812513,
    stopColor: "#FE7DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838555,
    stopColor: "#FF965D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTagRainbow);
export default __webpack_public_path__ + "static/media/ico_tag_rainbow.0bc84ce55e24b70371819d7ad8f8411b.svg";
export { ForwardRef as ReactComponent };